module.exports = __webpack_public_path__ + "static/the-big-bang-the-buddha-and-the-baby-boom-86363dd9062d2c986165c68f45813624.jpg";